import { ModalOptions } from "../../../models/modalOptions";
import { useTranslation } from "react-i18next";
import { Modal, OverlayTrigger } from "react-bootstrap";

const TooltipModal = (props: ModalOptions) => {
  const { t } = useTranslation();
  const { title, body, show, closeButtonHide, onHide } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      id="help-icon-modal"
      role="document"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header>
        <h1 className="modal-title small" id="help-icon-title">
          {title}
        </h1>
        {closeButtonHide ? undefined : (
          <OverlayTrigger placement="top" overlay={<></>}>
            <button
              type="button"
              className="btn-close"
              aria-label={t("buttons.close")}
              title={t("buttons.close")}
              onClick={onHide}
            />
          </OverlayTrigger>
        )}
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <button className="alt-btn alt-btn-luk" onClick={onHide}>
          {t("buttons.close")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TooltipModal;
